import { useEffect } from 'react';

/**
 * A custom React hook that automatically refetches the provided query when the browser tab become visible again.
 *
 * @param {import('@apollo/client').QueryResult} query - The Apollo Client query object to refetch.
 * @param {boolean} refetchCondition - A condition to determine whether to refetch the query.
 */
export default function useRefetchOnVisibility(query, refetchCondition = true) {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && refetchCondition) {
        query?.refetch();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [query, refetchCondition]);
}
